<script setup lang="ts">
const { t } = useI18n();
const localePath = useLocalePath();
const route = useRoute();

type NavKey = "home" | "computer" | "english";

const navItems = computed(() => [
  { key: "home" as const, name: t("nav.home"), path: "/" },
  { key: "computer" as const, name: "11th Computer", path: "/11th/computer/" },
  { key: "english" as const, name: "11th English", path: "/11th/english/" },
]);

const activeKey = computed<NavKey>(() => {
  const path = (route.path || "/").toLowerCase();

  if (path.startsWith("/11th/computer")) {
    return "computer";
  }

  if (path.startsWith("/11th/english")) {
    return "english";
  }

  return "home";
});
</script>

<template>
  <header class="sticky top-0 z-50 border-b border-gray-200 bg-white/95 shadow-sm backdrop-blur dark:border-gray-700 dark:bg-gray-900/95">
    <div class="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3">
      <NuxtLink
        :to="localePath('/')"
        class="flex shrink-0 items-center gap-3 text-xl font-bold text-gray-900 transition-colors hover:text-sky-600 dark:text-white dark:hover:text-sky-400"
      >
        <Icon name="heroicons:academic-cap" class="h-8 w-8" />
        <span class="hidden sm:inline">Ustaad</span>
      </NuxtLink>

      <nav class="flex min-w-0 flex-1 items-center justify-center gap-2 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none]">
        <NuxtLink
          v-for="item in navItems"
          :key="item.key"
          :to="localePath(item.path)"
          class="shrink-0 rounded-full border px-3 py-1.5 text-sm font-medium transition"
          :class="activeKey === item.key
            ? 'border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-700 dark:bg-sky-950/40 dark:text-sky-300'
            : 'border-gray-200 bg-white text-gray-700 hover:border-sky-300 hover:text-sky-700 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 dark:hover:border-sky-700 dark:hover:text-sky-300'"
        >
          {{ item.name }}
        </NuxtLink>
      </nav>

      <div class="ml-auto flex shrink-0 items-center gap-2">
        <ThemSwitcher />
      </div>
    </div>
  </header>
</template>
